module.exports = "<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\n<router-outlet></router-outlet>\n<modal-win-new-lead></modal-win-new-lead>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 1388
// module chunks = 9